import React, { useEffect } from 'react';
import { gapi } from 'gapi-script';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../context/notification.context";
import axios from 'axios';
import { Email } from '@mui/icons-material';

const CLIENT_ID = '544632141554-psm9su1gbt9083mvr296o3g077p31tab.apps.googleusercontent.com';
const SCOPE = 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid';

const GoogleAuthButton = () => {
  const navigate = useNavigate();
  const { getError, getSuccess } = useNotification();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const start = () => {
      gapi.client.init({
        clientId: CLIENT_ID,
        scope: SCOPE,
      });
    };

    gapi.load('client:auth2', start);
  }, []);

  const handleGoogleLogin = async () => {
    try {
      const auth = gapi.auth2.getAuthInstance();
      const googleUser = await auth.grantOfflineAccess({
        scope: SCOPE,
      });
      const code = googleUser.code;
  
      // Get user profile information
      const profile = auth.currentUser.get().getBasicProfile();
      let correo = profile.getEmail();
      let id = profile.getId();
      let nombre = profile.getName();
      console.log('Email: ' + profile.getEmail()); // Prints
      console.log('ID: ' + profile.getId()); // Prints user ID
      console.log('Full Name: ' + profile.getName()); // Prints full name
  
      // Enviar código de autorización a tu backend para procesarlo y subir archivo a Google Drive
      const response = await axios.post('http://localhost:5001/api/drive', {
        code: code,
        folderName: "Berhu_Folder",
        fileName: "Berhu.txt",
        fileContent: "Bienvenido a Berhu"
      });
  
      if (response.data.success) {
        getSuccess("Archivo subido a Google Drive exitosamente");
  
  
        if (id) {
          const sessionResponse = await axios.post("http://localhost:5001/api/driveSession", {
            correo,
            nombre,
            id 
          });
  
          if (sessionResponse.data.success) {
            localStorage.setItem("userId", sessionResponse.data.session_id);
            console.log("userId guardado en el localStorage:", sessionResponse.data.session_id);
            getSuccess("Sesión iniciada con éxito, Bienvenid@");
            navigate("/dash");
          } else {
            getError("Error al registrar la sesión en el backend");
            console.error("Error en la respuesta:", sessionResponse.data.message);
          }
        } else {
          console.error("Hint no encontrado en el localStorage");
        }
      } else {
        getError("Error al subir el archivo a Google Drive");
      }
    } catch (error) {
      getError("Error al iniciar sesión con Google");
      console.error('Error:', error);
    }
  };

  return (
    <Button
      onClick={handleGoogleLogin}
      variant="outlined"
      startIcon={<GoogleIcon />}
      sx={{
        mt: isMobile ? 3 : 1.5,
        mb: isMobile ? 1 : 3,
        mr: isMobile ? '' : 50,
        ml: isMobile ? 2 : 45,
        width: isMobile ? "320px" : "341px",
        borderRadius: "50px",
        fontSize: "16px",
        textTransform: "none",
        color: "black",
        borderColor: "black",
        "&:hover": {
          background: "#FEE483",
          borderColor: "#FEE483"
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px 24px"
      }}
    >
      Continuar con Google
    </Button>
  );
};

export default GoogleAuthButton;
